module.exports = "/images/vendor/desiigner-svg/svg/places/lighthouse.svg?2a6804780d60250d6cc20abd0ef4543f";